<!-- 个人信息 -->
<template>
    <div>
        <div class="poster">
            <img src="https://cdn.edstatic.com/203012120000/cb67d33eb37f6c21e5f8774a82ed45d6/2025/02/d061bd65-dc5a-4b2a-9efe-7ebc99cd564e.jpeg"
                alt="">
            <div class="btn" v-if="isWxBtn">
                前往wiki
            </div>
            <!-- 打开Medwki小程序 -->
            <wx-open-launch-weapp class="launch-btn" username="gh_4931ece2a2ce" appid="wxaa0bdd5050768d0e"
                :path="'pages/tab/home/home'" v-if="isWxBtn">
                <script type="text/wxtag-template">
                <style>
                     .mini-btn {
                        width:100%;
                        height: 100%;
                        position:absolute;
                        opacity: 0;
                        left:0;
                        top:0;
                        z-index:999
                    }
                </style> 
                <p class="mini-btn">前往wiki</p>
            </script>
            </wx-open-launch-weapp>

        </div>
        <tabbar :active="index"></tabbar>

    </div>


</template>
<script>
import Tabbar from '../components/Tabbar'
import { WxShare } from "../../../config/interface";
import wx from 'weixin-js-sdk'
export default {
    components: {
        Tabbar
    },
    data() {
        return {
            index: 1,
            isWxBtn: false

        }
    },
    created() {
        this.checkIOSAndReload();

    },
    mounted() {
        this.$nextTick(() => {
            this.getWxConfig()
        })
    },

    methods: {
        // 判断是否是 iOS 设备并刷新页面
        checkIOSAndReload() {
            const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
            if (isIOS && !sessionStorage.getItem('isReloaded')) {
                sessionStorage.setItem('isReloaded', 'true');
                window.location.reload();
            }
        },
        //微信配置
        getWxConfig() {
            let that = this
            if (common.is_weixin()) {
                const url = WxShare;
                let params = {
                    "jssdk": ["wx-open-launch-weapp"],
                    "url": location.href
                };
                const method = 'POST';
                fetch(url, params, method)
                    .then((res) => {
                        if (res.code == 0) {
                            wx.config({
                                debug: false, // 验证结果弹窗控制，微信环境可能会因为接口安全问题出现失败弹窗，所以直接设置的false，
                                appId: res.data.appId, // 公众号唯一appid
                                nonceStr: res.data.nonceStr,
                                timestamp: res.data.timestamp,
                                signature: res.data.signature,
                                jsApiList: ['wx-open-launch-weapp'],//随便填写的一个
                                openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app']
                            })
                            wx.ready(function (success) {
                                that.isWxBtn = true //表示验证成功
                                console.log('success', success)
                            })
                            wx.error(function (err) {
                                Toast.fail('暂不支持', err);
                                // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                                console.log('error', err)
                            })


                        }
                    })

            }
        },
    }
}
</script>
<style lang="scss">
.poster {
    width: 100%;
    position: relative;
    height: calc(100vh - 50px);


    img {
        width: 100%;
    }

    .btn {
        background: linear-gradient(90deg, #467FFF 0%, #467FFF 22%, #55B5FF 100%);
        width: 170px;
        height: 46px;
        color: #ffffff;
        font-size: 17px;
        font-weight: 500;
        position: absolute;
        bottom: 8%;
        left: 0;
        right: 0;
        text-align: center;
        margin: 0 auto;
        border-radius: 5px;
        line-height: 46px;
    }
}

.launch-btn {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
}

@media screen and (max-width:500px) {
    .poster {
        max-height: 100vh;
        overflow: hidden;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/wiki/index.vue